const TEMPLATE_NAME = 'PAD_PRESCRIPTION';

const initialState = () => ({
  loading: false,
  data: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        loading: false,
        data
      };
    }
    case `${TEMPLATE_NAME}VISIT_RESET`: {
      return initialState();
    }

    case `${TEMPLATE_NAME}VISIT_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}VISIT_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}VISIT_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        loading: false,
        data
      };
    }
    default:
      return state;
  }
};
export default reducer;
